import useSWR from "swr";
import { JSON_FETCHER } from "@/components/fetcher";

export type TeamRole = "admin" | "editor" | "viewer";

export const TEAM_ROLES = {
  ADMIN: "admin" as const,
  EDITOR: "editor" as const,
  VIEWER: "viewer" as const,
};

export function isAdmin(role: TeamRole | undefined | null): boolean {
  return role === TEAM_ROLES.ADMIN;
}

export function getRoleLabel(role: TeamRole): string {
  return role.charAt(0).toUpperCase() + role.slice(1);
}

export interface TeamMember {
  id: string;
  email: string;
  role: TeamRole;
  created_at: number;
  is_pending: boolean;
}

export interface TeamInfo {
  role: TeamRole;
  team_name: string | null;
  seat_limit: number;
  seat_count: number;
}

interface UseTeamMembersResult {
  members: TeamMember[];
  isLoading: boolean;
  isError: any;
}

export default function useTeamMembers(): UseTeamMembersResult {
  const { data, error } = useSWR("/web_api/team/members", JSON_FETCHER);

  return {
    members: data?.members || [],
    isLoading: !(data || error),
    isError: error,
  };
}
